export let properties = {};

export let sections = {
  ESTUDIANTES: 1000,
  NUEVO_ESTUDIANTE: 1001,
  VER_ESTUDIANTE: 1002,
  EDITAR_ESTUDIANTE: 1003,
  ELIMINAR_ESTUDIANTE: 1004,
  PAGAR_COMISION: 1005,
  LISTA_ESTUDIANTES: 1500,
  FILTRO_CODIGO: 1501,
  FILTRO_NOMBRE: 1502,
  FILTRO_APELLIDO: 1503,
  FILTRO_TELEFONO: 1504,
  FILTRO_ESPECIALIDAD: 1505,
  FILTRO_FECHA_REGISTRO: 1506,
  FILTRO_ESTADO_ESTUDIANTE: 1507,
  FILTRO_LIMITE: 1508,
  FILTRO_AGENCIA: 1509,
  FILTRO_FECHA_AGENDA: 1510,
  FILTRO_COMISION: 1511,
  FILTRO_SUPERVISOR: 1512,
  FILTRO_FECHA_LLAMAR: 1513,
  ADMINISTRACION: 2000,
};
